/*
====================================================================================================
   Handles all date related operations with the help of dayjs
 ===================================================================================================
 */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Ref : https://stackoverflow.com/questions/75499165/dayjs-format-and-convert-an-iso-date-time-string-to-local-timezones-date-time
dayjs?.extend(utc);
dayjs?.extend(timezone);

export const datesCreator = (): string[] => {
  // PST today
  const today = dayjs()?.tz('America/Los_Angeles')?.format('MM/DD/YY');

  // PST yesterday
  const yesterday = dayjs()
    ?.tz('America/Los_Angeles')
    ?.subtract(1, 'day')
    ?.format('MM/DD/YY');

  // PST tomorrow
  const tomorrow = dayjs()
    ?.tz('America/Los_Angeles')
    ?.add(1, 'day')
    ?.format('MM/DD/YY');

  return [yesterday, today, tomorrow];
};

export const dateFormatter = (date: string) => {
  // Convert date '07/15/24' to 15JUL24 with dayjs formatting
  return dayjs(date)?.format('DDMMMYY')?.toUpperCase();
};
